import { gql } from 'src/__generated__';

export const GET_VERIFICATIONS = gql(`
  query GetVerifications($jobId: ID!, $selectedAnswerUris: [String!]!, $zone: Zone) {
    viewer {
      _id
      verificationNudges(
          jobId: $jobId,
          selectedAnswerUris: $selectedAnswerUris,
          platform: WEB,
          source: JAS,
          zone: $zone
        ) {
          uri
          ctaLabel
          ctaUrl
          description
          rank
          verificationType
        }
    }
  }
`);
